import { Button } from '@/components/shadcn/button';
import { Card } from '@/components/shadcn/card';

interface BadmintonConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function BadmintonConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Hapus',
  onConfirm,
  onCancel,
}: BadmintonConfirmDialogProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
      role="presentation"
      onClick={onCancel}
    >
      <Card
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="badminton-confirm-title"
        aria-describedby="badminton-confirm-message"
        className="w-full max-w-sm rounded-3xl border-0 p-6 shadow-lg"
        onClick={(event) => event.stopPropagation()}
      >
        <h2 id="badminton-confirm-title" className="text-lg font-extrabold text-[#0E1726]">
          {title}
        </h2>
        <p id="badminton-confirm-message" className="mt-2 text-sm text-gray-500">
          {message}
        </p>
        <div className="mt-5 flex gap-2">
          <Button
            type="button"
            variant="outline"
            className="h-11 flex-1 rounded-full"
            onClick={onCancel}
          >
            Batal
          </Button>
          <Button
            type="button"
            className="h-11 flex-1 rounded-full bg-[#FC480D] font-bold text-white hover:bg-[#D83B08]"
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </Card>
    </div>
  );
}
